import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { InjectionToken, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';

import { isPinGateLocked } from './app/pin-gate/pin-gate';
import { globalConfig } from './global.config';
import { MpsAppComponent } from './mps/components/mps-app/mps-app.component';
import { MpsPostLoginUrlHelper } from './mps/helpers/mps-post-login-url.helper';

registerLocaleData(localeFr); // MPS TODO: Adapt to your locale

// Only point that beats the race between the boot-time 401 redirect to the provider and the
// router's own redirect to the login page, so it is the one that catches email deep links.
MpsPostLoginUrlHelper.capture(window.location.pathname + window.location.search + window.location.hash);

export const OAUTH2_PROVIDERS_URL = new InjectionToken<string>('OAUTH2_PROVIDERS_URL');
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
export const LOADER_ON_HTTP = new InjectionToken<string>('LOADER_ON_HTTP');

if (isPinGateLocked()) {
  bootstrapPinGate();
} else {
  bootstrapApplication(MpsAppComponent, {
    ...globalConfig,
    providers: [provideZoneChangeDetection(), ...globalConfig.providers],
  }).catch((err) => console.error(err));
}

/**
 * Environments with `pinGuardActivated: true` boot the access-code screen and nothing else:
 * `globalConfig` is never applied, so no initializer runs, no API call is made and no OAuth
 * redirect can fire before the code is entered. Entering it reloads the page, `isPinGateLocked()`
 * is then false, and the application boots normally on the same URL.
 *
 * The component is imported lazily so it stays out of the main bundle on PROD, where the gate
 * is off.
 */
function bootstrapPinGate(): void {
  const host = document.createElement('app-pin-gate');
  document.body.replaceChildren(host);

  import('./app/pin-gate/pin-gate.component')
    .then(({ PinGateComponent }) =>
      bootstrapApplication(PinGateComponent, {
        providers: [provideZoneChangeDetection(), provideAnimations()],
      })
    )
    .catch((err) => console.error(err));
}
